export class SendTokenRequest {
    user: string;
    email: string;
    process: string;
    observations: string;

    constructor() {
        this.user = "";
        this.email = "";
        this.process = "";
        this.observations = "";
    }
}